import { Link } from "react-router-dom";
import type { Category } from "@/types";
import { categoryPath } from "@/utils/slug";

export default function CategoryCard({
  category,
  showImage = false,
  placeSlug,
}: {
  category: Category;
  showImage?: boolean;
  /** When set, links to the location-scoped SEO URL (e.g. /category/restaurants-in-mysore). */
  placeSlug?: string;
}) {
  const hasImage = showImage && Boolean(category.image);

  return (
    <Link
      to={categoryPath(category.slug, placeSlug)}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
    >
      {hasImage ? (
        <div className="relative h-40 w-full overflow-hidden">
          <img
            src={category.image}
            alt={`${category.name} business category`}
            title={`${category.name} listings`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-md bg-background-50/90 text-primary-700 backdrop-blur">
            <i className={`${category.icon} text-lg`}></i>
          </span>
        </div>
      ) : null}

      <div className="flex flex-1 flex-col p-4">
        {!hasImage ? (
          <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
            <i className={`${category.icon} text-2xl`}></i>
          </span>
        ) : null}
        <span className="mt-4 block font-heading text-sm font-bold leading-snug text-foreground-950">{category.name}</span>
        <span className="mt-1 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-500">
          {category.description}
        </span>
        <span className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <span className="text-xs font-semibold text-foreground-600">
            {category.businessCount.toLocaleString()} listings
          </span>
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}